import React from 'react'
import translations from './translations'

translations.add('es', {
    paymentTimedOut: 'El pago ha caducado. Inténtelo de nuevo.',
    close: 'Cerrar'
})
